"use strict";
import { useEffect, useRef } from "react";
import { getNativeAddress } from "constants/uniswapAddresses";
import { FeatureFlags } from "features/gating/flags";
import { useFeatureFlag } from "features/gating/hooks";
import { UniswapEventName } from "features/telemetry/constants/uniswap";
import { sendAnalyticsEvent } from "features/telemetry/send.web";
import { getTokenProtectionFeeOnTransfer } from "features/tokens/safetyUtils";
export function useBlockaidFeeComparisonAnalytics(currencyInfo) {
  const isBlockaidFotLoggingEnabled = useFeatureFlag(FeatureFlags.BlockaidFotLogging);
  const sentEventCurrencyIdRef = useRef();
  const { buyFeePercent, sellFeePercent } = getTokenProtectionFeeOnTransfer(currencyInfo);
  const blockaidBuyFeePercent = currencyInfo?.safetyInfo?.blockaidFees?.buyFeePercent ?? 0;
  const blockaidSellFeePercent = currencyInfo?.safetyInfo?.blockaidFees?.sellFeePercent ?? 0;
  useEffect(() => {
    if (!currencyInfo || !isBlockaidFotLoggingEnabled) {
      return;
    }
    const normalizedBuyFee = buyFeePercent ?? 0;
    const normalizedSellFee = sellFeePercent ?? 0;
    if (sentEventCurrencyIdRef.current !== currencyInfo.currencyId && currencyInfo.currency.symbol && currencyInfo.currency.chainId && (normalizedBuyFee !== blockaidBuyFeePercent || normalizedSellFee !== blockaidSellFeePercent)) {
      const address = currencyInfo.currency.isToken ? currencyInfo.currency.address : getNativeAddress(currencyInfo.currency.chainId);
      sendAnalyticsEvent(UniswapEventName.BlockaidFeesMismatch, {
        symbol: currencyInfo.currency.symbol,
        address,
        chainId: currencyInfo.currency.chainId,
        buyFeePercent,
        sellFeePercent,
        blockaidBuyFeePercent: currencyInfo?.safetyInfo?.blockaidFees?.buyFeePercent,
        blockaidSellFeePercent: currencyInfo?.safetyInfo?.blockaidFees?.sellFeePercent,
        attackType: currencyInfo.safetyInfo?.attackType,
        protectionResult: currencyInfo.safetyInfo?.protectionResult
      });
      sentEventCurrencyIdRef.current = currencyInfo.currencyId;
    }
  }, [
    buyFeePercent,
    sellFeePercent,
    blockaidBuyFeePercent,
    blockaidSellFeePercent,
    currencyInfo,
    isBlockaidFotLoggingEnabled
  ]);
}
